import { StyleSheet } from 'aphrodite'

import row from './row'
import list from './list'
import status from './status'

export default {
  list: StyleSheet.create(list),
  row: StyleSheet.create(row),
  status: StyleSheet.create(status)
}



// WEBPACK FOOTER //
// ./src/components/User/partials/CommunityTable/style/ColorBlind/index.js